import { alpha, Theme } from "@mui/material";

import { IAssistantWalkthroughFeatureModel } from "api/services/chat/assistant";

import { AssistantScenarioStatusEnum } from "../../enums";
import { getAssistantScenarioCounts } from "../../utils";
import { assistantScenarioStatusPresentation } from "./constants";
import { IAssistantScenarioStyleProps } from "./types";

export function getAssistantScenarioChecklist(
  feature: IAssistantWalkthroughFeatureModel
) {
  const { completed, skipped } = getAssistantScenarioCounts(feature.scenarios);
  const scenarios = feature.scenarios.map(({ guide, status }) => {
    return {
      id: guide.id,
      status,
      title: guide.title,
      ...assistantScenarioStatusPresentation[status],
    };
  });

  return {
    scenarios,
    completed,
    skipped,
    unfinished: scenarios.length - completed - skipped,
  };
}

export function getAssistantScenarioColors(
  theme: Theme,
  status: IAssistantScenarioStyleProps["status"]
) {
  const colors = {
    symbolBackground: theme.palette.custom.semantic.surface.subtle,
    statusForeground: theme.palette.custom.semantic.text.muted,
    statusBackground: theme.palette.custom.semantic.surface.subtle,
    segmentBackground: theme.palette.custom.semantic.border.subtle,
  };

  if (status === AssistantScenarioStatusEnum.COMPLETED) {
    const background = alpha(
      theme.palette.custom.forest_green,
      theme.palette.action.focusOpacity
    );

    return {
      symbolBackground: background,
      statusForeground: theme.palette.custom.forest_green,
      statusBackground: background,
      segmentBackground: theme.palette.custom.forest_green,
    };
  }

  if (status === AssistantScenarioStatusEnum.IN_PROGRESS) {
    return {
      symbolBackground: theme.palette.secondary.main,
      statusForeground: theme.palette.custom.dark_golden,
      statusBackground: alpha(
        theme.palette.secondary.main,
        theme.palette.action.focusOpacity
      ),
      segmentBackground: theme.palette.secondary.main,
    };
  }

  if (status === AssistantScenarioStatusEnum.SKIPPED) {
    return {
      ...colors,
      segmentBackground: theme.palette.custom.semantic.text.muted,
    };
  }

  return colors;
}
